module.exports = __webpack_public_path__ + "img/home-visual-02.ee5107de.jpg";